import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const TableHeader = ({...props}) => {

  return (
    <TableHead
      style={{ position: "sticky", top: "0", backgroundColor: "#001753", zIndex: 100 }}
      >
      <TableRow>
        {props.isGroups &&
          <TableCell align="right" style={{ color: "white", width: '80px' }}>
            Products
          </TableCell>
        }
        <TableCell align="right" style={{ color: "white", width: '90px'  }}>
          Id
        </TableCell>
        <TableCell align="right" style={{ color: "white" }}>
          Name
        </TableCell>
        {!props.isGroups &&
          <TableCell align="center" style={{ color: "white" }}>
            Stock
          </TableCell>
        }
        <TableCell align="center" style={{ color: "white", width: "150px" }}>
          Image
        </TableCell>
        <TableCell align="center" style={{ color: "white", width: "100px" }}>
          Edit
        </TableCell>
        <TableCell align="center" style={{ color: "white", width: "100px" }}>
          Delete
        </TableCell>
      </TableRow>
    </TableHead>    
  );
};

export default TableHeader;
